import React from "react";

import SupportInfo from "./supportInfo";

import DownloadInfo from "./downloadInfo";
import MaintainanceMode from "./maintainanceMode";

import LogoSetup from "./logo";
import AdminQR from "./admin-qr";
import GeneralSettings from "./general-settings";
import ModuleWisePercent from "./module-wise-percent";
import BusinessRule from "./business-rule";
import ModuleWisePrice from "./module-wise-price";

const General = () => {
  return (
    <>
      <MaintainanceMode />
      <br />
      <SupportInfo />
      <br />
      <GeneralSettings />
      <br />
      <AdminQR />
      <br />
      <DownloadInfo />
      <br />
      <ModuleWisePercent />
      <br />
      <ModuleWisePrice />
      <br />
      <BusinessRule />
      <br />
      <LogoSetup />
    </>
  );
};

export default General;
